export default "__VITE_ASSET__DBFbiBt7__"